import { Icon } from '@iconify/react';

// Search tab configuration based on client-specific pages from navigationConfig.js
export const searchTabConfig = {
  // Helios admin tabs (same as current admin tabs)
  helios: {
    tabs: [
      {
        id: 'best-match',
        label: 'Best Match',
        icon: 'material-symbols:star',
        count: 0
      },
      {
        id: 'clients',
        label: 'Clients',
        icon: 'fluent:organization-16-filled',
        count: 0
      },
      {
        id: 'activity',
        label: 'Activity',
        icon: 'hugeicons:activity-04',
        count: 0
      },
      {
        id: 'notes',
        label: 'Andy Notes',
        icon: 'material-symbols:note-alt-rounded',
        count: 0
      }
    ]
  },

  // Wards specific tabs (based on wards_specific category)
  wards: {
    tabs: [
      {
        id: 'best-match',
        label: 'Best Match',
        icon: 'material-symbols:star',
        count: 0
      },
      {
        id: 'tickets',
        label: 'Tickets',
        icon: 'material-symbols:confirmation-number',
        count: 0
      },
      {
        id: 'calls',
        label: 'Calls',
        icon: 'material-symbols-light:call-log',
        count: 0
      },
      {
        id: 'orders',
        label: 'Orders',
        icon: 'material-symbols:order-approve-outline',
        count: 0
      },
      {
        id: 'inventory',
        label: 'Inventory',
        icon: 'lsicon:inventory-filled',
        count: 0
      }
    ]
  },

  // Kronk specific tabs (based on CHAT_AI category + kronk-home)
  kronk: {
    tabs: [
      {
        id: 'best-match',
        label: 'Best Match',
        icon: 'material-symbols:star',
        count: 0
      },
      {
        id: 'tickets',
        label: 'Tickets',
        icon: 'material-symbols:confirmation-number',
        count: 0
      },
      {
        id: 'chat-history',
        label: 'Chat History',
        icon: 'ph:chats-fill',
        count: 0
      },
      {
        id: 'orders',
        label: 'Orders',
        icon: 'material-symbols:order-approve-outline',
        count: 0
      }
    ]
  },

  // Scale specific tabs (based on VOICE_AI category + scale-home)
  scale: {
    tabs: [
      {
        id: 'best-match',
        label: 'Best Match',
        icon: 'material-symbols:star',
        count: 0
      },
      {
        id: 'tickets',
        label: 'Tickets',
        icon: 'material-symbols:confirmation-number',
        count: 0
      },
      {
        id: 'calls',
        label: 'Calls',
        icon: 'material-symbols-light:call-log',
        count: 0
      },
      {
        id: 'insights',
        label: 'Insights',
        icon: 'proicons:graph',
        count: 0
      }
    ]
  },

  // Kokoro specific tabs (based on REMEMBRANCE_AI category + kokoro-home)
  kokoro: {
    tabs: [
      {
        id: 'best-match',
        label: 'Best Match',
        icon: 'material-symbols:star',
        count: 0
      },
      {
        id: 'tickets',
        label: 'Tickets',
        icon: 'material-symbols:confirmation-number',
        count: 0
      }
    ]
  },

  // Default for other organizations - only tickets and best match
  default: {
    tabs: [
      {
        id: 'best-match',
        label: 'Best Match',
        icon: 'material-symbols:star',
        count: 0
      },
      {
        id: 'tickets',
        label: 'Tickets',
        icon: 'material-symbols:confirmation-number',
        count: 0
      }
    ]
  }
};

// Helper function to get search tab config for a customer
export const getSearchTabConfig = (customerId) => {
  return searchTabConfig[customerId] || searchTabConfig.default;
};

// Helper function to check if a tab is supported for a customer
export const isTabSupported = (customerId, tabId) => {
  const config = getSearchTabConfig(customerId);
  return config.tabs.some(tab => tab.id === tabId);
};
